/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Subject, interval } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import {
	Component,
	Input,
	ChangeDetectionStrategy,
	OnChanges,
	SimpleChanges,
	Self,
	Optional,
	AfterViewInit,
	ChangeDetectorRef,
} from '@angular/core';
import { TicketEditBaseComponent } from '../ticket-edit-base/ticket-edit-base.component';
import { NgControl } from '@angular/forms';
import { MultiWrapperComponent } from '../multi-wrapper/multi-wrapper.component';

import { trigger, transition, style, animate, state, keyframes, sequence } from '@angular/animations';

/**
 * This component displays an optional message at the top of the edit mode.
 * It's meant for informational things like "Viewing in read only mode" or
 * "Drag ticket or tap date...".
 */
@Component({
	selector: 'ticket-message',
	templateUrl: './ticket-message.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	animations: [
		trigger('fadeIn', [
			state('void', style({ opacity: 0 })),
			state('*', style({ opacity: 1 })),
			transition('void => *', animate('250ms ease-in')),
		]),
	],
})
export class TicketMessageComponent extends TicketEditBaseComponent implements OnChanges, AfterViewInit {
	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef
	) {
		super(control, multiWrapper, cd);
	}

	/**
	 * @input seems like we just need text.  The mockups show some bolding
	 * so perhaps we need some kind of markup support too.
	 */
	@Input() public message: string;
	public bounceMessage = new Subject<void>();
	public deadTimePassed = false;
	// private deadTimeMessage: string;

	public ngAfterViewInit() {
		interval(600)
			.pipe(take(1), takeUntil(this.shutdownSubject))
			.subscribe(() => {
				this.deadTimePassed = true;
				if (this && this.bounceMessage) {
					this.bounceMessage.next();
					this.cd.detectChanges();
				}
			});
	}

	public ngOnChanges(changes: SimpleChanges) {
		const ch = changes['message'];
		if (!ch.firstChange && ch.previousValue !== ch.currentValue) {
			this.bounceMessage.next();
		}
	}
}
